'use strict'

const pluginsManager = require('./pluginsManager')()
const fixPageData = require('./fixPageData')
const pluginsConfig = require('./config.json')

module.exports = {
    fixPageData: fixPageData.factory(pluginsManager, pluginsConfig)
}
